module.exports = __webpack_public_path__ + "static/media/feature-split-image-00.0f531442.png";